module.exports = __webpack_public_path__ + "static/media/kapcsolat.d61357ef.jpg";